import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Creditor, CreditorAccount } from '@feature/creditor-accounts/models/creditor-account-model';
import { CreditorAccountsHttpService } from '@feature/creditor-accounts/services/creditor-account-http.service';

@Injectable()
export class CreditorAccountService {

  constructor(private readonly creditorAccountsHttpService: CreditorAccountsHttpService) {

  }

  getCreditorAccounts(): Observable<CreditorAccount[]> {
    return this.creditorAccountsHttpService.getCreditorAccounts();
  }

  getCreditorAccountsBySupplierRef(supplierRef: number): Observable<CreditorAccount[]> {
    return this.creditorAccountsHttpService.getCreditorAccountsBySupplierRef(supplierRef);
  }

  getUserCreditors() {
    return this.creditorAccountsHttpService.getUserCreditors();
  }

}

